// extracted by mini-css-extract-plugin
export default {"app":"ViewFolder_app__HuHMT","header":"ViewFolder_header__QzJfq","list":"ViewFolder_list__QweLT","bottomAdd":"ViewFolder_bottomAdd__APFKa","back":"ViewFolder_back__l5XRN"};